<template>
  <div class="landing-container" id="nav-scroller" ref="content">
    <auth-modal></auth-modal>
    <navbar></navbar>
    <header-section ref="headerSectionOuter"></header-section>
    <brands-section></brands-section>
    <quote-section></quote-section>
    <capsule-section></capsule-section>
    <b-container>
      <wardrobe-section></wardrobe-section>
      <community-section></community-section>
    </b-container>

    <hr />

    <b-container>
      <div id="get-access">
        <intro-block>
          <form-horizontal slot="form"></form-horizontal>
        </intro-block>
      </div>
    </b-container>
    <br />
    <br />
    <br />

    <footer>
      <div
        class="
          d-flex
          flex-column flex-md-row
          align-items-center
          p-3
          px-md-4
          bg-white
          border-top
        "
      >
        <h5 class="my-0 mr-md-auto font-weight-normal navbar-brand">
          UNSTITCHED
        </h5>
        <nav class="my-2 my-md-0 mr-md-3 footer-link-list">
          <router-link
            class="header-link p-2 text-dark"
            :to="{ name: 'DiscoverCapsules' }"
          >
            <i class="pe-7s-scissors align-middle pr-1"></i>
            <span class="align-middle">Capsules</span>
          </router-link>
          <router-link
            class="header-link p-2 text-dark"
            :to="{ name: 'Community' }"
          >
            <i class="pe-7s-chat align-middle pr-1"></i>
            <span class="align-middle">Community</span>
          </router-link>
          <a
            class="header-link p-2 text-dark"
            href="https://www.instagram.com/unstitched.xyz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="~@/assets/img/instagram.svg"
              class="feather feather-instagram align-middle pr-1"
            />
            <span class="align-middle">Instagram</span>
          </a>
        </nav>
        <a
          class="btn btn-outline-secondary get-in-touch"
          href="mailto:paris@unstitched.xyz"
          >Get in touch</a
        >
      </div>
    </footer>
  </div>
</template>

<script>
import AuthModal from "@/components/formModal/AuthModal";
import BrandsSection from "@/components/landing/BrandsSection";
import Navbar from "@/components/landing/Navbar";
import HeaderSection from "@/components/landing/HeaderSection";
import IntroBlock from "@/components/landing/IntroBlock";
import FormHorizontal from "@/components/landing/FormHorizontal";
import CapsuleSection from "@/components/landing/CapsuleSection";
import WardrobeSection from "@/components/landing/WardrobeSection";
import CommunitySection from "@/components/landing/CommunitySection";
import SignUpModal from "@/components/landing/SignUpModal";
import QuoteSection from "@/components/landing/QuoteSection";

import { mapActions } from "vuex";
import { bus } from "@/main";

export default {
  mounted() {
    this.setShowHeader(false);
    window.analytics.page("Landing");
  },

  destroyed() {
    this.setShowHeader(true);
  },

  components: {
    AuthModal,
    BrandsSection,
    Navbar,
    HeaderSection,
    IntroBlock,
    FormHorizontal,
    CapsuleSection,
    WardrobeSection,
    CommunitySection,
    SignUpModal,
    QuoteSection,
  },

  methods: {
    ...mapActions(["setShowHeader"]),
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

$font-dir: "~@/assets/fonts/";
@font-face {
  font-family: "Lombok";
  src: url("#{$font-dir}Lombok/Lombok.eot");
  src: url("#{$font-dir}Lombok/Lombok.eot?#iefix") format("embedded-opentype"),
    url("#{$font-dir}Lombok/Lombok.woff") format("woff"),
    url("#{$font-dir}Lombok/Lombok.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

.landing-container {
  overflow: hidden;
  background: #ffffff;

  .pe-7s-map {
    font-size: 24px;
  }

  .pe-7s-scissors {
    font-size: 26px;
  }

  .pe-7s-chat {
    font-size: 22px;
  }

  .footer-link-list {
    @include for-sm-phone-only {
      display: flex;

      .header-link {
        text-align: center;
      }
    }
    @include for-phone-only {
      display: flex;

      .header-link {
        text-align: center;
      }
    }
  }
}

.navbar-brand {
  font-size: 32px;
  color: $primary-blue;
  font-family: "Lombok";
}

.btn {
  font-weight: 300 !important;
}

.header-link:hover {
  text-decoration: none !important;
}

.get-in-touch {
  font-weight: 400 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Landing.vue